export const formatPaymentMethodMixin = {
  methods: {
    $_formatPaymentMethod(paymentMethod) {
      const paymentMethods = {
        QR_PAYMENT: 'QR Payment',
        CREDIT_PAYMENT: 'Credit / Debit Card'
      };

      return paymentMethod ? paymentMethods[paymentMethod] : '-';
    }
  }
};
